import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as irActions from '../../../redux/actions/irSearchActions';

import DeadlineCases from './DeadlineCases';

const type = 'schedule';
const noDataFoundMessage = 'There are no Deadline/Hearing events for this case.';

export class DeadlineCasesContainer extends Component {
  componentDidMount() {
    if (this.props.purchase_right_away) { this.purchaseData(); } else { this.getData(); }
  }

    getData = () => {
      this.props.dispatch(irActions.getCaseData({
        type,
        case_uuid: this.props.case_uuid,
      }));
    }

  purchaseData = () => {
    this.props.dispatch(irActions.purchaseCaseData({
      type,
      case_uuid: this.props.case_uuid,
    }));
  }

  render() {
    return (
      <DeadlineCases
        {...this.props}
        type={type}
        purchaseData={this.purchaseData}
        noDataFoundMessage={noDataFoundMessage}
      />
    );
  }
}

DeadlineCasesContainer.defaultProps = {
  purchase_right_away: false,
  error: null,
  receipt: null,
};

DeadlineCasesContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  case_uuid: PropTypes.any.isRequired,
  purchase_right_away: PropTypes.bool,
  dataReady: PropTypes.bool.isRequired,
  deadlines: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  error: PropTypes.any,
};

const mapStateToProps = (state) => {
  const irSearch = state.get('irSearch').toJS();
  return {
    dataReady: irSearch.data_ready,
    deadlines: irSearch.data,
    receipt: irSearch.receipt,
    lastUpdated: irSearch.lastUpdated,
    error: irSearch.error,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(DeadlineCasesContainer);



// WEBPACK FOOTER //
// ./src/components/case/deadlines/DeadlineCasesContainer.js